import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Inject,
  OnInit,
} from "@angular/core";
import { MAT_DIALOG_DATA } from "@angular/material/dialog";
import { Subscription } from "rxjs";
import { BrandCampaignInsightService } from "../../shared/services/brand-campaign-insight.service";
import { BrandCampaignPartnerStatusChartDialogViewModel } from "./brand-campaign-partner-status-chart-dialog.view-model";

export interface BrandCampaignPartnerStatusChartDialogData {
  campaignId: number;
}

export type BrandCampaignPartnerStatusChartDialogResult = undefined;

@Component({
  selector: "app-brand-campaign-partner-status-chart-dialog",
  styleUrls: ["./brand-campaign-partner-status-chart-dialog.component.scss"],
  templateUrl: "./brand-campaign-partner-status-chart-dialog.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BrandCampaignPartnerStatusChartDialogComponent implements OnInit {
  public vm: BrandCampaignPartnerStatusChartDialogViewModel;

  private readonly subscriptions = new Subscription();

  constructor(
    brandCampaignInsightService: BrandCampaignInsightService,
    cdr: ChangeDetectorRef,
    @Inject(MAT_DIALOG_DATA)
    data: BrandCampaignPartnerStatusChartDialogData,
  ) {
    this.vm = new BrandCampaignPartnerStatusChartDialogViewModel(
      brandCampaignInsightService,
      data.campaignId,
    );

    this.subscriptions.add(this.vm.state$.subscribe(() => cdr.markForCheck()));
  }

  public ngOnInit(): void {
    this.vm.init();
  }
}
